import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
let _ = t => t,
  _t;
const _excluded = ["children"];
import styled, { mediaQuery, css, academyPageFullWidth, academyResultsBar } from 'academy-common-lib/utils/Styling';
import { MY_PLAYLISTS_URL_FRAGMENT } from '../../../constants/Navigation';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BackButton } from '../../navigation';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import styledWithTheme from 'foundations-theming/utils';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const Subheader = styled(_ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("nav", Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(TFlex, {
      align: "center",
      justify: "between",
      children: children
    })
  }));
}).withConfig({
  displayName: "PlaylistPageHeader__Subheader"
})(["", " & > div{height:100%;", ";}padding-right:12px;padding-left:12px;", ";"], academyResultsBar, academyPageFullWidth, mediaQuery('notMobile', css(["padding-right:12px;padding-left:24px;"])));
export const PlaylistBackButton = styledWithTheme(BackButton)(_t || (_t = _`
  ${0}

  ${0}
`), mediaQuery('mobile', css(["color:", " !important;"], ({
  theme: trellisTheme
}) => trellisTheme.color['text-interactive-default'])), mediaQuery('notMobile', css(["color:", " !important;"], ({
  theme: trellisTheme
}) => trellisTheme.color['text-core-on-fill-default'])));
export const PlaylistPageHeader = () => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isMobile && /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      backgroundColor: "fill-surface-default",
      inlineSize: "100%",
      justifyContent: "space-between",
      paddingInline: "400",
      children: /*#__PURE__*/_jsx(View, {
        paddingBlock: "200",
        children: /*#__PURE__*/_jsx(PlaylistBackButton, {
          exact: true,
          to: MY_PLAYLISTS_URL_FRAGMENT,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.myPlaylists"
          })
        })
      })
    })
  });
};